"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventStatus;
(function (EventStatus) {
    EventStatus[EventStatus["Active"] = 0] = "Active";
    EventStatus[EventStatus["Archived"] = 1] = "Archived";
    EventStatus[EventStatus["Deleted"] = 2] = "Deleted";
})(EventStatus || (EventStatus = {}));
exports.default = EventStatus;
